var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 132,
    viewBox: "0 0 380 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 58.7897C60.3141 58.7897 74.488 56.3897 87.7125 51.7265C100.937 47.0634 112.953 40.2286 123.075 31.6123C133.196 22.9959 141.225 12.7669 146.703 1.50909C152.181 -9.74868 155 -21.8147 155 -34L46 -34L46 58.7897Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341 21.3333C341 15.5202 339.655 9.76391 337.042 4.39323C334.428 -0.977451 330.598 -5.85737 325.77 -9.96791C320.941 -14.0785 315.208 -17.3391 308.9 -19.5637C302.591 -21.7883 295.829 -22.9333 289 -22.9333V21.3333H341Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289 58.7897C282.171 58.7897 275.409 59.9347 269.1 62.1593C262.792 64.3839 257.059 67.6446 252.23 71.7551C247.402 75.8657 243.572 80.7456 240.958 86.1163C238.345 91.487 237 97.2432 237 103.056L289 103.056V58.7897Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80.9231C28.1713 80.9231 21.4094 82.0681 15.1005 84.2927C8.79153 86.5173 3.05909 89.778 -1.76955 93.8885C-6.5982 97.999 -10.4285 102.879 -13.0417 108.25C-15.655 113.62 -17 119.377 -17 125.19L35 125.19L35 80.9231Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294 132C305.294 132 316.477 130.106 326.911 126.427C337.345 122.748 346.825 117.355 354.811 110.557C362.797 103.759 369.132 95.6884 373.454 86.8061C377.776 77.9238 380 68.4038 380 58.7897L294 58.7897V95.3949V132Z",
    fill: "white",
    fillOpacity: 0.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircle);
export default __webpack_public_path__ + "static/media/bg-circle.b8db48ee3e65b924a9f4f2feb9c47ae3.svg";
export { ForwardRef as ReactComponent };